/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    // Generate all valid yardage values from 0.5 to 100.0 with increments of 0.125
    function generateValidYardageValues() {
        let values = [];
        for (let i = 0.5; i <= 100.0; i += 0.125) {
            values.push(parseFloat(i.toFixed(3))); // Ensure the values are stored with three decimal places
        }
        return values;
    }
    
    // List of valid yardage values
    const validValues = generateValidYardageValues();
    
    $(document).on('click', '.ajax-submit', function (e) {
        e.preventDefault();
        // Check if the yard calculator is enabled by the metafield
        var enableYardCalculator = $('#yardage-calculator').data('enable-yard-calculator') || '';
        const $addToCartForm = $(this).closest('form');
        let productVariantId = document.querySelector('[name="id"]').value; // Get the product variant ID
        let mainProductQty = parseInt($addToCartForm.find('[name="quantity"]').val()) || 1;
    
        if (!productVariantId) {
            console.error('Product Variant ID is not defined.');
            return;
        }

        var addOnSelectedVariants = [];
        $(".productCheckbox:checked").each(function () {
            var variantId = $(this).data("variant-id");
            addOnSelectedVariants.push({ id: variantId, quantity: 1 });
        });
        console.log("enableYardCalculatortrue", enableYardCalculator)
        if (!enableYardCalculator == '' && enableYardCalculator == true) {
            let yardageInputElement = document.querySelector('#yardage-input');
            let yardageInput = yardageInputElement.value.trim(); // Get the yardage input from the user
    
            // Convert the input to a float
            let yardage = parseFloat(yardageInput);
    
            // Convert yardage to 1/8-yard units
            let units = yardage * 8;
    
            // Validate the input: Check if the input is empty, invalid, or doesn't match valid sequence
            if (!yardageInput || isNaN(yardage) || units < 4 || !validValues.includes(yardage)) {
                alert('Please enter a valid yardage.');
                return false;
            }
    
            let yardageData = {
                id: productVariantId,
                quantity: units,       // Quantity in 1/8-yard units
                properties: {
                    'Total Yardage': yardage % 1 === 0 ? `${yardage.toFixed(0)} yards` : `${yardage.toFixed(2)} yards`
                }
            };
                
            console.log("addOnSelectedVariants == " + addOnSelectedVariants);
    
            // If add-ons are selected, send them along with yardageData
            if (addOnSelectedVariants.length > 0) {
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: { items: addOnSelectedVariants.concat([yardageData]) }, // Add yardage data with add-ons
                    dataType: "json",
                    success: function (data) {
                        console.log("Add-ons and yardage added to cart", data);
                        Shopify.theme.jsAjaxCart.showDrawer();
                        Shopify.theme.jsAjaxCart.updateView();
                    },
                    error: function () {
                        console.log("ERROR");
                        Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
                    }
                });
            } else {
                // If no add-ons, just add the yardage data
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: yardageData,
                    dataType: "json",
                    success: function (data) {
                        console.log('Yardage item added to cart:', data);
                        Shopify.theme.jsAjaxCart.showDrawer();
                        Shopify.theme.jsAjaxCart.updateView();
                    },
                    error: function () {
                        console.log("ERROR");
                        Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
                    }
                });
            }
        } else {
          if (addOnSelectedVariants.length > 0) {              
            let mainProductData = {
                id: productVariantId,
                quantity: mainProductQty
            };
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: { items: addOnSelectedVariants.concat([mainProductData]) },
                dataType: "json",
                success: function (data) {
                    console.log("Add-ons and main product added to cart", data);
                    Shopify.theme.jsAjaxCart.showDrawer();
                    Shopify.theme.jsAjaxCart.updateView();
                },
                error: function () {
                    console.log("ERROR");
                    Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
                }
            });
        } else {      
            Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
            console.log('hemloooo');
          }
        }
    
        return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();

      return false;
    });
    var enableYardCalculator1 = $('#yardage-calculator').data('enable-yard-calculator') || '';
    // Yard input Code and validations
    if (!enableYardCalculator1 == '' && enableYardCalculator1 == true) {
      document.querySelector('#yardage-input').addEventListener('input', function () {
        let inputValue = this.value.trim();
        let errorElement = document.querySelector('#yardage-error');
        let suggestionElement = document.querySelector('#yardage-suggestion');
        let atcBtn = document.querySelector('.purchase-details__buttons button.ajax-submit');
        const availableQty = $('#yardage-calculator').data('qty');
        
        // Hide previous error and suggestion
        errorElement.style.display = 'none';
        atcBtn.disabled = false;
        atcBtn.removeAttribute('title');
        suggestionElement.style.display = 'none';

        // Remove any non-numeric characters except for the decimal point
        let sanitizedInput = inputValue.replace(/[^\d.]/g, ''); 
        
        // Check if the input is a valid number and if the format is correct
        let value = parseFloat(sanitizedInput);

        // Regular expression for valid fraction or whole number format (e.g., 0.5, 1.125, 2, etc.)
        const validFormatRegex = /^(\d+(\.\d{1,3})?)$/; 

        // If the value is less than 0.5, suggest 0.5
        if (value < 0.5 || !validFormatRegex.test(sanitizedInput)) {
            errorElement.style.display = 'inline';
            atcBtn.disabled = true;
            suggestionElement.style.display = 'inline';
            suggestionElement.textContent = `0.5 yards`;
        } 
        // Ensure the value is a multiple of 1/8 yard (e.g., 0.125, 0.25, 0.375, etc.)
        else if (value % 0.125 !== 0) {
            // Suggest the nearest valid value (round to nearest 1/8 yard)
            let nearestValidValue = (Math.round(value / 0.125) * 0.125).toFixed(3);
            errorElement.style.display = 'inline';
            atcBtn.disabled = true;
            suggestionElement.style.display = 'inline';
            suggestionElement.textContent = `${nearestValidValue} yards`;
        } 
        // Check against available inventory if limited
        else if (typeof availableQty !== 'undefined') {
            const calculatedQty = value * 8; // Convert yards to 1/8-yard units
            
            if (calculatedQty > availableQty) {
                errorElement.style.display = 'inline';
                atcBtn.disabled = true;
                atcBtn.title = `Only ${availableQty/8} yards available (${availableQty} units)`;
                suggestionElement.style.display = 'inline';
                suggestionElement.textContent = `${availableQty/8} yards (max available)`;
            }
        }
        // If the value is valid, hide the error and suggestion
        else {
            errorElement.style.display = 'none';
            suggestionElement.style.display = 'none';
        }

        // Update the input field with the sanitized value
        this.value = sanitizedInput;
      });

      // Additional safeguard on submit
      $(document).on('click', '.ajax-submit', function(e) {
        const availableQty = $('#yardage-calculator').data('qty');
        if (typeof availableQty !== 'undefined') {
          const yardage = parseFloat($('#yardage-input').val()) || 0;
          const calculatedQty = yardage * 8;
          
          if (calculatedQty > availableQty) {
            e.preventDefault();
            alert(`Only ${availableQty/8} yards available (${availableQty} units).\nYou requested ${yardage} yards (${calculatedQty} units).`);
            return false;
          }
        }
      });
    }

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('html').addClass('overflow-hidden');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('html').removeClass('overflow-hidden');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {

          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              Shopify.theme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();

          if (Shopify.theme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = (response.message) ? response.message : response.description;
          
          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          
          $('.warning').remove();

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        const total_price = options.total_price

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
        
        /* Update shipping indicator asynchronously js */
        if($('[data-fs-threshold]').length){
          let $parent = $('[data-fs-threshold]')
          let $remainingWrapper = $parent.find('.fs-indicator__remaining')
          let $successWrapper = $parent.find('.fs-indicator__success')
          
          let fs_threshold = $('[data-fs-threshold]').data('fs-threshold');
          if(fs_threshold >= total_price){
            //udpate
            let fs_remaining = fs_threshold - total_price;
            let fs_remaining_percent = total_price / fs_threshold * 100
            
            $remainingWrapper.find('.bar').css('width', fs_remaining_percent + '%')
            $remainingWrapper.find('[data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_remaining))
            
            $remainingWrapper.removeClass('is-hidden')
            $successWrapper.addClass('is-hidden')
          }else{
            //remove shipping indicator
            $remainingWrapper.addClass('is-hidden')
            $successWrapper.removeClass('is-hidden')
          }
        }

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }
      
      if (Shopify.theme.currencyConverter) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;